// @react/hooks/useBillingInvoiceNumbering.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { billingInvoiceNumberingStore } from '@core/stores';

/**
 * React hook for InvoiceNumberingScheme operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useBillingInvoiceNumbering } from '@react/hooks';
 *
 * const InvoiceNumberingSchemeList = observer(() => {
 *   const store = useBillingInvoiceNumbering();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useBillingInvoiceNumbering() {
  return billingInvoiceNumberingStore;
}
